<template>
	<!-- 榜单三合一（吸顶） -->
	<!-- TODO 吸顶功能 -->
	<div class="container" :ddt-area="`component_${floorId}_榜单三合一组件`" ddt-expose="on">
		<!-- NOTE 主标题 副标题区域 -->
		<!-- NOTE "titleType": 1, //主标题样式 1:文字 2:图片 0 不显示标题 -->
		<template v-if="titleInfo.titleType != 0">
			<div
				v-if="titleInfo.titleType == 2"
				class="top-title-wrapper-image"
				:style="{ '--title-bg-image': `url(${titleInfo.imageUrl})` }"
			></div>
			<div v-else class="top-title-wrapper">
				<div v-if="titleInfo.title" class="main-title">{{ titleInfo.title }}</div>
				<div class="right">
					<div
						class="jump"
						v-if="titleInfo.subTitle"
						@click.native="$sys.dict.href(titleInfo.imageUrl)"
					>
						{{ titleInfo.subTitle || "查看全部" }}
						<van-icon name="arrow" />
					</div>
				</div>
			</div>
		</template>

		<!-- tab sticky-->
		<van-tabs
			v-if="tabData.length > 1"
			class="tab-component"
			:class="{ isBorderRadius: titleInfo.titleType == 0 }"
			:background="floorConfig.tabInfo.bgColor || '#fff'"
			:title-active-color="floorConfig.tabInfo.selectedColor"
			:title-inactive-color="floorConfig.tabInfo.titleColor"
			color="#D3AD72"
			v-model="active"
			:line-width="isTabBottomLine ? '0' : '40px'"
			:line-height="isTabBottomLine ? '0' : '3px'"
			:style="{
				'--tab-bg-image': `url(${floorConfig.tabInfo.titleBgImageUrl})`,
				'--tab-select-bg-image': `url(${floorConfig.tabInfo.selectBgImageUrl})`,
			}"
		>
			<van-tab
				v-for="(item, index) of tabData"
				title-class="main-tab"
				:key="item.name"
				:name="item.category + item.name"
				:title="item.name"
				:ddt-src="item.name"
				:data-area="pt()"
				:data-pos="`component_${floorId}_三合一tab组件.tab${index + 1}_点击`"
				:data-desc="item.name"
				:dd_name="`${pt()}.component_${floorId}三合一tab组件.tab${index + 1}_点击.${item.name}`"
				:ddt-click="`${pt()}.component_${floorId}_三合一tab组件.坑位${index + 1}_点击.${item.name}`"
				:ddt-pit="`坑位${index + 1}_点击`"
				ddt-expose="on"
			>
				<!-- {{ active }} {{ index }} {{ item.category }} -->
				<!-- {{ active == item.category + item.name }} -->
				<good-list
					ref="goodListRef"
					:curIndex="index"
					:key="item.category + item.name"
					:isActivate="active == item.category + item.name"
					:tabItem="item"
					:pagesize="floorConfig.productCount"
				/>
			</van-tab>
		</van-tabs>
		<!-- NOTE 只有一个tab 不显示tab -->
		<template v-else>
			<good-list :isActivate="true" :pagesize="floorConfig.productCount" />
		</template>
	</div>
</template>

<script>
import goodList from "./components/good-list.vue";

export default {
	name: "speBangThreeinone",
	components: {
		goodList,
	},
	props: {
		json: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			floorId: "",
			titleInfo: {},
			floorConfig: {
				// tabInfo: {
				// 	bgColor: "#D42020",
				// 	selectBgImageUrl: "https://img62.ddimg.cn/2023/6/16/2023061615022949715.png",
				// 	selectedColor: "#189670",
				// 	titleBgImageUrl: "https://img62.ddimg.cn/2023/9/4/2023090410322438979.png",
				// 	titleColor: "#EFEF22"
				// }
			},
			tabData: [],
			active: 0,
		};
	},
	computed: {
		isTabBottomLine() {
			return (
				this.floorConfig?.tabInfo?.titleBgImageUrl ||
				this.floorConfig?.tabInfo?.selectBgImageUrl
			);
		},
	},
	inject: ["pt"],
	watch: {
		json: {
			handler(newVal) {
				console.log("三合一data-newVal", newVal);
				let { data, floorId } = newVal;
				if (!data) {
					return;
				}
				this.floorId = floorId;
				let { body, titleInfo, floorConfig } = data;
				this.titleInfo = titleInfo;
				this.floorConfig = floorConfig;
				this.tabData = body;
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {},
};
</script>

<style lang="less" scoped>
.container {
	::v-deep .main-tab {
		background-image: var(--tab-bg-image);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	::v-deep .main-tab.van-tab--active {
		background-image: var(--tab-select-bg-image);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	.tab-component.isBorderRadius > ::v-deep .van-tabs__wrap {
		border-radius: 16px 16px 0 0;
	}
	background-color: transparent;
	// background: #f12727;
	padding: 0 14px;
	padding-top: 20px;
	padding-bottom: 20px;
	.top-title-wrapper-image {
		height: 88px;
		background-image: var(--title-bg-image);
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	.top-title-wrapper {
		display: flex;
		border-radius: 16px 16px 0 0;
		justify-content: space-between;
		background-color: #fff;
		--height: 88px;
		.main-title {
			height: var(--height);
			display: inline-flex;
			align-items: center;
			margin-left: 20px;
			align-self: center;
			font-size: 34px;
			color: #141414;
			font-weight: 600;
		}

		.right {
			// height: var(--height);
			align-self: center;
			font-size: 24px;
			color: #999999;
			margin-right: 20px;
			.jump {
				cursor: pointer;
				user-select: none;
			}
		}
	}
}
</style>
